import React from 'react';

const OrderStatusMatrix = ({ data }) => {
    if (!data || !data.matrix || data.matrix.length === 0) return null;

    const statuses = data.statuses || {};
    const statusKeys = Object.keys(statuses);

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Order Status by Location</h6>
                <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Location</th>
                                {statusKeys.map(sk => (
                                    <th key={sk} className="text-center">{statuses[sk]}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {data.matrix.map((row, i) => (
                                <tr key={i}>
                                    <td>{row.location_name}</td>
                                    {statusKeys.map(sk => (
                                        <td key={sk} className="text-center">{row[sk] || 0}</td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default OrderStatusMatrix;
